import { Tag, Typography } from "antd";
import React from "react";

interface Props {
  color: string;
  icon: React.ReactNode;
  text: string;
}

export const HistoryItemStatus: React.FC<Props> = ({ color, icon, text }) => {
  return (
    <Typography.Text className="block font-medium ml-1 my-1">
      <Tag color={color} icon={icon}>
        {text}
      </Tag>
    </Typography.Text>
  );
};
